type Props = {
  /** Full URL to the file */
  href: string;
  /** Filename hint for the downloaded file */
  filename?: string;
  className?: string;
  title?: string;
  children: React.ReactNode;
};

export function ProtectedDownload({
  href,
  filename,
  className,
  title,
  children,
}: Props): React.JSX.Element {
  return (
    <a href={href} download={filename} className={className} title={title}>
      {children}
    </a>
  );
}

ProtectedDownload.displayName = 'ProtectedDownload';
